import axios, { AxiosError, AxiosInstance } from 'axios';
import { GipsyInstanceType } from 'global';
import humps from 'humps';
import { sendError } from 'services/error-webhook';
import { AppViews } from '../endpoints';

const GipsyyGDSApi: AxiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_INSTANCE_TYPE === GipsyInstanceType.BRAZIL
      ? process.env.REACT_APP_GDS_WEB_API_BR
      : process.env.REACT_APP_GDS_WEB_API_PT,
  transformResponse: [
    ...(axios.defaults.transformResponse as []),
    (data) => {
      if (data instanceof Blob) return data;
      return humps.camelizeKeys(data);
    },
  ],
});

GipsyyGDSApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response != null && error.response.status === 401) {
      localStorage.removeItem('authData');
      window.location.href = AppViews.AGENCY_LOGIN;
    }
    sendError(error, window.location.href, error.response?.request.responseURL);
    return Promise.reject(error);
  },
);

export default GipsyyGDSApi;
